import { createApp } from 'vue';

import vuetify from './plugins/vuetify';
import perfectScrollbar from './plugins/perfectScrollbar';

import 'tippy.js/dist/tippy.css';

import router from './router';
import store from './store';

import i18n from './lang/i18n';

import App from './App.vue';

const app = createApp(App);

app.use(router);
app.use(store);

app.use(i18n);

app.use(vuetify);
app.use(perfectScrollbar);

app.mount('#app');
